import { createAction, props } from '@ngrx/store';

import { GridDefault } from '../models/custom-category.models';

import { Category } from '@core/domain/models/category.models';
import { ProductsArrayPublicModels } from '@features/products/productsArray';

export const CategoryActionTypes = {
    CHANGE_CUSTOM_CATEGORY: '[Custom Category Grid] CHANGE_CUSTOM_CATEGORY',
    REORDER_PRODUCT_IDS_CUSTOM_CATEGORY: '[Custom Category Grid] REORDER_PRODUCT_IDS_CUSTOM_CATEGORY',
    DISABLE_CUSTOM_CATEGORY_GRID_EFFECTS: '[Custom Category Grid] DISABLE_CUSTOM_CATEGORY_GRID_EFFECTS',
    INIT_CUSTOM_CATEGORY_GRID_EFFECTS: '[Custom Category Grid] INIT_CUSTOM_CATEGORY_GRID_EFFECTS',
    INIT_CUSTOM_CATEGORY_GRID: '[Custom Category Grid] INIT_CUSTOM_CATEGORY_GRID',
    LOAD_CUSTOM_CATEGORY_PRODUCTS_SUCCESS: '[Custom Category Grid] LOAD_CUSTOM_CATEGORY_PRODUCTS_SUCCESS',
    LOAD_CUSTOM_CATEGORY_PRODUCTS: '[Custom Category Grid] LOAD_CUSTOM_CATEGORY_PRODUCTS',
    LOAD_FIRST_PAGE_GRID_CUSTOM_CATEGORY: '[Custom Category Grid] LOAD_FIRST_PAGE_GRID_CUSTOM_CATEGORY',
    LOAD_LAST_PAGE_CUSTOM_CATEGORY_SUCCESS: '[Custom Category Grid] LOAD_LAST_PAGE_CUSTOM_CATEGORY_SUCCESS',
    LOAD_NEXT_PAGE_CUSTOM_CATEGORY_SUCCESS: '[Custom Category Grid] LOAD_NEXT_PAGE_CUSTOM_CATEGORY_SUCCESS',
    LOAD_NEXT_PAGE_CUSTOM_CATEGORY_ERROR: '[Custom Category Grid] LOAD_NEXT_PAGE_CUSTOM_CATEGORY_ERROR',
    LOAD_NEXT_PAGE_CUSTOM_CATEGORY: '[Custom Category Grid] LOAD_NEXT_PAGE_CUSTOM_CATEGORY',
    SCROLL_TO_CUSTOM_CATEGORY_POSITION_ID: '[Custom Category Grid] SCROLL_TO_CUSTOM_CATEGORY_POSITION_ID',
    SET_CUSTOM_CATEGORY_GRIDTYPE_SUCCESS: '[Custom Category Grid] SET_CUSTOM_CATEGORY_GRIDTYPE_SUCCESS',
    SET_CUSTOM_CATEGORY_GRIDTYPE: '[Custom Category Grid] SET_CUSTOM_CATEGORY_GRIDTYPE',
    SET_CUSTOM_CATEGORY_TOTAL_CUANTITY_PRODUCTS: '[Custom Category Grid] SET_CUSTOM_CATEGORY_TOTAL_CUANTITY_PRODUCTS',
};

export const InitCustomCategoryGrid = createAction(CategoryActionTypes.INIT_CUSTOM_CATEGORY_GRID);

export const ChangeCustomCategory = createAction(
    CategoryActionTypes.CHANGE_CUSTOM_CATEGORY,
    props<{ category: Category }>()
);

export const ReorderProductIdsCustomCategory = createAction(
    CategoryActionTypes.REORDER_PRODUCT_IDS_CUSTOM_CATEGORY,
    props<{ productIds: number[] }>()
);

export const ScrollToCustomCategoryPositionId = createAction(
    CategoryActionTypes.SCROLL_TO_CUSTOM_CATEGORY_POSITION_ID,
    props<{ id: string }>()
);

export const SetGridTypeCustomCategoryGrid = createAction(
    CategoryActionTypes.SET_CUSTOM_CATEGORY_GRIDTYPE,
    props<{ initGridType?: boolean }>()
);

export const SetCustomCategoryTotalQuantityProducts = createAction(
    CategoryActionTypes.SET_CUSTOM_CATEGORY_TOTAL_CUANTITY_PRODUCTS,
    props<{ totalQuantityProducts: number }>()
);

export const LoadNextPageCustomCategory = createAction(CategoryActionTypes.LOAD_NEXT_PAGE_CUSTOM_CATEGORY);

export const LoadNextPageCustomCategorySuccess = createAction(
    CategoryActionTypes.LOAD_NEXT_PAGE_CUSTOM_CATEGORY_SUCCESS,
    props<{ ids: number[]; page: number }>()
);

export const LoadNextPageCustomCategoryError = createAction(
    CategoryActionTypes.LOAD_NEXT_PAGE_CUSTOM_CATEGORY_ERROR,
    props<{ error: unknown }>()
);

export const LoadLastPageCustomCategorySuccess = createAction(CategoryActionTypes.LOAD_LAST_PAGE_CUSTOM_CATEGORY_SUCCESS);

export const LoadFirstPageCustomCategory = createAction(
    CategoryActionTypes.LOAD_FIRST_PAGE_GRID_CUSTOM_CATEGORY,
    props<{ grid: GridDefault }>()
);

export const LoadCustomCategoryProducts = createAction(
    CategoryActionTypes.LOAD_CUSTOM_CATEGORY_PRODUCTS,
    props<{ name: string }>()
);

export const LoadCustomCategoryProductsSuccess = createAction(
    CategoryActionTypes.LOAD_CUSTOM_CATEGORY_PRODUCTS_SUCCESS,
    props<{
        data: Array<{
            categoryGrids: ProductsArrayPublicModels.PublicCategoryPlatformStudio;
            productsSource: string;
        }>;
    }>()
);

export const InitCustomCategoryGridEffects = createAction(
    CategoryActionTypes.INIT_CUSTOM_CATEGORY_GRID_EFFECTS,
);

export const DisableCustomCategoryGridEffects = createAction(
    CategoryActionTypes.DISABLE_CUSTOM_CATEGORY_GRID_EFFECTS,
);
